export default __webpack_public_path__ + "static/media/cityEn.a08700bd.png";